<template>
  <div
    class="auth__container"
    style="background-color: #f6f8fb;">

    <div
      v-if="!isAuthCheckStatusInProgress && !isLoginPageEnabled"
      class="ro-admin-login-error"
      style="background-color: #f6f8fb;">
      <el-card class="error_container">

        <div
          class="mx-24 my-24 el-text el-text--display-medium"
          style="text-align: center;">
          {{ $t('error.root-admin-login.title') }}
        </div>

        <div
          class="mx-24 mb-24"
          style="text-align: center;">
          {{ $t('error.root-admin-login.message') }}
        </div>

      </el-card>
    </div>

    <el-card
      v-if="!isAuthCheckStatusInProgress && isLoginPageEnabled"
      class="auth__form-container"
    >
      <div class="mx-24 my-24 auth__form-title">
        <div class="el-text el-text--display-medium mb-8">
          {{ $t('login.form.title') }}
        </div>
      </div>

      <el-form
        :model="loginForm"
        :rules="formRules"
        @submit="onSubmit"
      >
        <el-form-item
          class="mx-24 mt-16"
          prop="username"
        >
          <el-input
            name="username"
            v-model="loginForm.username"
            :label="$t('login.form.hint.user')"
          />
        </el-form-item>

        <el-form-item
          class="mx-24"
          prop="password"
          style="margin-bottom: -8px;"
        >
          <el-password
            name="password"
            v-model="loginForm.password"
            :label="$t('login.form.hint.password')"
            with-icon
          />
        </el-form-item>

        <el-checkbox
          class="remember mx-24"
          style="margin-bottom: -8px;"
          v-model="loginForm.remember"
          @change="onRememberMeChange"
        >
          {{ $t('login.form.checkbox.remember-me') }}
        </el-checkbox>

        <template v-if="isAuthError">
          <el-form-error
            class="mx-24 my-16"
            style="margin-bottom: -8px;"
            size="large"
            show-icon
          >
            {{ $t('login.form.message.invalid-user-credentials') }}
          </el-form-error>
        </template>

        <div class="mx-24 mt-24">
          <el-button
            :loading="isAuthInProgress"
            :disabled="isAuthInProgress"
            fluid
            native-type="submit"
            size="large"
          >
            {{ $t('login.form.button.sign-in') }}
          </el-button>
        </div>

        <div
          class="mx-24 mb-24"
          style="margin-top: 18px; text-align: center;">
          <el-button
            @click="onForgotPassword"
            type="text">
            {{ $t('login.form.button.forgot-password') }}
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { AUTH_LOGIN } from '../store/action-types';
import { ERROR_AUTH_STATUS, PENDING_AUTH_STATUS } from '../store/auth-status';

const isGoogleAnalyticsEnabled = process.env.VUE_APP_GTM_ID.length > 1;

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.form.message.user-required')));
      } else {
        callback();
      }
    };

    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.form.message.password-required')));
      } else {
        callback();
      }
    };

    return {
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      formRules: {
        username: [
          { validator: validateUsername }
        ],
        password: [
          { validator: validatePassword }
        ]
      }
    };
  },
  computed: {
    isLoginPageEnabled() {
      return this.$store.state.loginPageEnabled;
    },
    subscription() {
      return this.$store.state.subscription;
    },
    authenticated() {
      return this.$store.state.authenticated;
    },
    isAuthError() {
      if (this.$store.state.authStatus === ERROR_AUTH_STATUS) {
        this.sendAthStatistics(false, this.urlSubscriptionType);
        return true;
      }
      return false;
    },
    isAuthInProgress() {
      return this.$store.state.authStatus === PENDING_AUTH_STATUS;
    },
    isAuthCheckStatusInProgress() {
      return this.$store.state.authCheckStatus === PENDING_AUTH_STATUS;
    },
    urlSubscriptionType() {
      return window.location.href.toLowerCase().includes('/enterprise') ? 'WRE' : 'WRH';
    }
  },
  watch: {
    authenticated(authenticated) {
      if (authenticated) {
        this.redirectToApp();
      }
    }
  },
  methods: {
    onSubmit: function () {
      this.$store.dispatch(AUTH_LOGIN, {
        username: this.loginForm.username,
        password: this.loginForm.password,
        remember: this.loginForm.remember,
        subscription: this.urlSubscriptionType
      });
    },
    redirectToApp() {
      if (this.subscription === 'WRE') {
        // this.$router.go(-1);
        this.$router.push('/enterprise/dashboard');
        this.sendAthStatistics(true, this.subscription);
      } else {
        // this.$router.go(-1);
        this.$router.push('/dashboard');
        this.sendAthStatistics(true, this.subscription);
      }
    },
    onRememberMeChange(value) {
      if (value && isGoogleAnalyticsEnabled) {
        this.$gtm.push({
          event: 'Acronis',
          eventCategory: this.urlSubscriptionType === 'WRE' ?
            'WRE_authorization' : 'WR_authorization',
          eventAction: 'Remember_me_checkbox',
          eventLabel: ''
        });
      }
    },
    onForgotPassword() {
      if (isGoogleAnalyticsEnabled) {
        this.$gtm.push({
          event: 'Acronis',
          eventCategory: this.urlSubscriptionType === 'WRE' ?
            'WRE_authorization' : 'WR_authorization',
          eventAction: 'Forgot_password',
          eventLabel: ''
        });
      }
      window.open(this.$t('login-page.link.forgot-password'), '_blank');
    },
    sendAthStatistics(isSuccess, subscription) {
      if (isGoogleAnalyticsEnabled) {
        this.$gtm.push({
          event: 'Acronis',
          eventCategory: subscription === 'WRE' ?
            'WRE_authorization' : 'WR_authorization',
          eventAction: 'Login',
          eventLabel: isSuccess ? '1' : '0'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .auth__container {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .auth__form-container {
    width: 512px;
  }

  .auth__form-title {
    text-align: center;
  }

  .ro-admin-login-error {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .error_container {
    width: 512px;
  }
</style>
